<template lang="pug">
div
  validation-provider(:rules="requiredTelefones ? 'required' : ''", v-slot="{ errors }", :name="nomeAba + '/Telefone(s)'")
    el-table(v-model="telefonesValidationValues" hidden :data="telefones")
  validation-provider(:rules="requiredTelefones ? 'required' : ''", :name="nomeAba + '/Telefone(s)'")
    app-label(label="Telefone(s):", :required="true")
    el-input.input(
      label='Telefone',
      v-mask="['(##) #####-####', '(##) ####-####']",
      :class="{'erro' : errorsTelefone && errorsTelefone.length}"
      v-model="fone"
    )
      el-button.style(
        slot="append",
        icon="el-icon-plus",
        @click="addTelefone(fone)",
        :disabled="fone.length < 14",
      )
    span.help.erro {{ errorsTelefone ? errorsTelefone[0] : '' }}

    div.tag-app-input.marginTop
      el-tag(
        v-for="(telefone, index) in telefonesNovos",
        :key="index",
        closable,
        type="info",
        size="medium",
        @close="removeTelefone(telefone)"
      ) {{ telefone }}
</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'

export default {

  components: {
    AppLabel
  },

  data () {
    return {
      fone: '',
      telefonesNovos: null,
      telefonesAll: null,
      requiredTelefones: this.telefones === 0
    }
  },

  props: {
    telefones: {
      type: Array,
      required: true
    },

    nomeAba: {
      type: String,
      required: true
    },

    observer: {
      required: true
    }
  },

  created () {
    this.telefonesNovos = this.telefones
    this.requiredTelefones = this.telefones.length === 0
  },

  computed: {
    errorsTelefone () {
      if (this.observer) {
        return this.observer.errors[ this.nomeAba + '/Telefone(s)' ]
      }
      return []
    },

    telefonesValidationValues () {
      return { telefonesNovos: this.telefones }
    }

  },

  methods: {
    ...mapActions('retificacao', ['update']),
    addTelefone (fone) {
      this.telefonesNovos = [...this.telefonesNovos, fone]
      this.fone = ''
      this.requiredTelefones = this.telefonesNovos.length === 0
    },

    removeTelefone (fone) {
      this.telefonesNovos = this.telefonesNovos.filter(tel => tel !== fone)
      this.requiredTelefones = this.telefonesNovos.length === 0
    },

    clearInput () {
      this.fone = ''
    }

  },

  watch: {
    'telefonesNovos' (val) {
      if (val.length > 0) {
        const fieldDinamico = this.nomeAba === 'Interessado'
          ? 'interessado.pessoa.telefones'
          : 'cadastrante.pessoa.telefones'
        this.update({field: fieldDinamico, value: val})
      }
    }
  }

}

</script>

<style lang="scss" scoped>

.marginTop {
  margin-top: 5px;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppInputTelefoneRetificacao.vue